import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { scrollToElement } from "@/utils/GlobalJavascriptFunction";
import stl from "./carDetailsSection.module.css";
import SinglePanel from "./SinglePanel";
import MojazSection from "../MojazSection/MojazSection";
import { useTranslation } from "@i18n";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
var CarDetailsSection = function CarDetailsSection(_ref) {
  var _postDetails$details;
  var sections = _ref.sections,
    fuelEco = _ref.fuelEco,
    mojazData = _ref.mojazData,
    screen_view_referral = _ref.screen_view_referral;
  var _usePostDetails = usePostDetails(),
    postDetails = _usePostDetails.postDetails;
  var _useTranslation = useTranslation(["web_post_view"]),
    t = _useTranslation.t;
  var _useState = useState(0),
    activePan = _useState[0],
    setActivePan = _useState[1];
  var _setNewPan = function setNewPan(val) {
    setActivePan(val == activePan ? null : val);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("h2", null, t("معلومات السيارة", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.pansContainer
  }, /*#__PURE__*/React.createElement(SinglePanel, {
    idSep: "00009",
    key: 0,
    isActive: activePan == 0,
    setNewPan: function setNewPan() {
      _setNewPan(0);
      setTimeout(function () {
        scrollToElement(document.querySelector(".scrollTmeMF" + "00009"), -70);
      }, 100);
    },
    has2columns: true,
    title: t("معلومات السيارة", {
      ns: "web_post_view"
    }),
    data: postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$details = postDetails.details) === null || _postDetails$details === void 0 ? void 0 : _postDetails$details.details_card,
    fuelEco: fuelEco
  }), mojazData && /*#__PURE__*/React.createElement(MojazSection, {
    data: mojazData,
    screen_view_referral: screen_view_referral
  }), (sections === null || sections === void 0 ? void 0 : sections.length) > 0 && sections.map(function (item, idx) {
    var Sep = idx;
    return /*#__PURE__*/React.createElement(SinglePanel, {
      idSep: Sep,
      hasIdForScroll: idx == 0,
      key: idx + 1,
      isActive: activePan == idx + 1,
      setNewPan: function setNewPan() {
        _setNewPan(idx + 1);
        setTimeout(function () {
          scrollToElement(document.querySelector(".scrollTmeMF" + Sep), -70);
        }, 100);

        // document.querySelector("#backToMe").click();
      },
      title: item.category,
      data: item.data
    });
  }))));
};
export default CarDetailsSection;